import { I18nLocales, ICountries, ILocales } from '@/interfaces/locales.interfaces';

export const determineLocaleCountry = (locale: string | undefined) => {
    switch (locale) {
        case ILocales.en_AU:
            return ICountries.Australia;
        case ILocales.en_NZ:
        default:
            return ICountries.NewZealand;
    }
};

export const determinei18nLocale = (locale: ILocales): I18nLocales => {
    switch (locale) {
        case ILocales.en_AU:
            return I18nLocales.au;
        case ILocales.en_NZ:
        default:
            return I18nLocales.nz;
    }
};

export const determineNextLocale = (locale: I18nLocales): ILocales => {
    switch (locale) {
        case I18nLocales.au:
            return ILocales.en_AU;
        case I18nLocales.nz:
        default:
            return ILocales.en_NZ;
    }
};
